import { css } from '@emotion/react';
 
export const positionElementFull = css`
    inset: 0;
    @supports not (inset: 0) {
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
    }
`;
